import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'filter-multiselect',
  templateUrl: './filter-multiselect.component.html',
  styleUrls: ['./filter-multiselect.component.scss'],
})
export class FilterMultiselectComponent implements OnInit {
  @Input()
  value :number[] | string[] | string | number;

  @Input()
  label :string;

  @Input()
  options ?:{ multi ?:boolean; options ?:any } = { multi: true, options: [] };

  @Output()
  changeSelection :EventEmitter<number[] | string[] | string | number> =
    new EventEmitter<any[]>();

  constructor() {}

  ngOnInit() :void {
    this.checkConfig();
  }

  onChange() :void {
    this.changeSelection.emit(this.value);
  }

  private checkConfig() :void {
    if (
      this.value &&
      this.options.multi &&
      Array.isArray(this.options.options) &&
      this.options.options.length > 0
    ) {
      this.value = String(this.value).split(',');
    }
  }
}
